import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'

import 'element-ui/lib/theme-chalk/index.css'
import echarts from 'echarts' // 引入echarts
Vue.prototype.$echarts = echarts // 引入组件

import register from '../src/components/register'
import orderInquery from '../src/components/orderInquery'
import hexCalc from '../src/components/hexCalc'
import getSuperPassword from '../src/components/getSuperPassword'
import resetPassword from '../src/components/resetPassword'
import copyData from '../src/components/copydata'
import deviceShow from '../src/components/deviceShow'
import Student from '../src/components/Student'
import editTemp from '../src/components/editTemp'
import openidBind from '../src/components/openidBind'
const routes = [
  {
    path: '/', component: register, meta: {
      title: '冷链云平台用户注册'
    }
  },
  {
    path: '/openidBind', component: openidBind, meta: {
      title: '温控物联公众号绑定'
    }
  },
  {
    path: '/Inquery', component: orderInquery, meta: {
      title: '冷链云平台订单明细查询'
    }
  },
  {
    path: '/hexCalc', component: hexCalc, meta: {
      title: '计算传感器ID'
    }
  },
  {
    path: '/getSuperPassword', component: getSuperPassword, meta: {
      title: '得到超级密码'
    }
  },
  {
    path: '/resetPassword', component: resetPassword, meta: {
      title: '密码重置'
    }
  },
  {
    path: '/copyData', component: copyData, meta: {
      title: '设备数据拷贝'
    }
  },
  {
    path: '/deviceShow', component: deviceShow, meta: {
      title: '设备明细'
    }
  },
  {
    path: '/Student', component: Student, meta: {
      title: '方便病友，微信在线咨询'
    }
  },
  {
    path: '/editTemp', component: editTemp, meta: {
      title: '温度计记录编辑'
    }}
]

Vue.config.productionTip = false
const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  console.log('222')
  console.log(to)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
Vue.use(VueRouter)
Vue.use(ElementUI)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
